/**
 * Facebook catalog ads: pinned-product redirect (collection page half).
 *
 * Reads the `pin` parameter left by fb-catalog-pin-redirect.js, fetches
 * that single product's card via the Section Rendering API (so it's
 * styled identically to the rest of the grid), and prepends it to the
 * top of the collection's product grid — regardless of where that
 * product would normally fall in the collection's sort order.
 *
 * If the product also appears naturally further down the visible grid,
 * that duplicate is removed so it isn't shown twice.
 */
(() => {
  const configEl = document.getElementById('fb-catalog-pin-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  if (!config || !config.enabled) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const params = new URLSearchParams(window.location.search);
  const handle = params.get(config.pinParam || 'pin');
  if (!handle) return;

  const grid = document.querySelector('ul.product-grid');
  if (!grid) return;

  const sectionId = config.pinnedCardSectionId || 'pinned-product-card';
  const url = `/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`;

  fetch(url)
    .then((response) => (response.ok ? response.text() : null))
    .then((html) => {
      if (!html) return;

      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();

      const card = wrapper.querySelector('[data-pinned-product="true"]');
      if (!card) return;

      const productId = card.getAttribute('data-product-id');
      if (productId) {
        const duplicate = grid.querySelector(
          `[data-product-id="${productId}"]:not([data-pinned-product])`
        );
        if (duplicate) duplicate.remove();
      }

      grid.prepend(card);
    })
    .catch(() => {});
})();
